// src/components/dashboards/MasterDashboard.js — SMOOTH CORNERS + LIGHT GREEN BG
import React from "react";
import DailyMoneyCard from "../summary/DailyMoneyCard";
import OverallMoneyCard from "../summary/OverallMoneyCard";
import DailyGrainCard from "../summary/DailyGrainCard";
import OverallGrainCard from "../summary/OverallGrainCard";
import MoneyCharts from "../charts/MoneyCharts";
import GrainCharts from "../charts/GrainCharts";
import RecentMoneyTable from "../tables/RecentMoneyTable";
import RecentGrainTable from "../tables/RecentGrainTable";
import "../summary/SummaryCard.css";
import "../charts/ChartContainer.css";
import "../tables/RecentTable.css";

export default function MasterDashboard() {
    return (
        <div className="container-fluid mt-4 fade-in">
            <div className="row g-4">
                {/* Money Section */}
                <div className="col-lg-6">
                    <div
                        className="glass-container p-4"
                        style={{
                            background: "rgba(52, 211, 153, 0.08)",
                            borderRadius: "24px",
                            border: "1px solid rgba(52, 211, 153, 0.2)"
                        }}
                    >
                        <h5 className="text-success mb-4 fw-bold">Money</h5>

                        <div className="summary-card daily-card mb-4">
                            <h6 className="summary-card-title">Today's Report</h6>
                            <DailyMoneyCard />
                        </div>

                        <div className="summary-card overall-card mb-4">
                            <h6 className="summary-card-title">Overall Report</h6>
                            <OverallMoneyCard />
                        </div>

                        <MoneyCharts />


                        <RecentMoneyTable />

                    </div>
                </div>

                {/* Grain Section */}
                <div className="col-lg-6">
                    <div
                        className="glass-container p-4"
                        style={{
                            background: "rgba(52, 211, 153, 0.08)",
                            borderRadius: "24px",
                            border: "1px solid rgba(52, 211, 153, 0.2)"
                        }}
                    >
                        <h5 className="text-success mb-4 fw-bold">Grain</h5>

                        <div className="summary-card daily-card mb-4">
                            <h6 className="summary-card-title">Today's Report</h6>
                            <DailyGrainCard />
                        </div>

                        <div className="summary-card overall-card mb-4">
                            <h6 className="summary-card-title">Overall Report</h6>
                            <OverallGrainCard />
                        </div>



                        <GrainCharts />
                        <RecentGrainTable />
                    </div>
                </div>
            </div>
        </div>
    );
}